import axios from 'axios';
import * as actions from '../actions/beforeAuth';

const api =
  ({ dispatch }: any) =>
  (next: any) =>
  async (action: any) => {
    if (action.type !== actions.authApiCallBegan.type) {
      return next(action);
    }

    const { url, method, data, onAuthStart, onAuthSuccess, onAuthFailed, onAuthReset } = action.payload;
    if (onAuthStart) {
      dispatch({ type: onAuthStart });
    }
    next(action);

    try {
      if (onAuthReset) {
        return dispatch({ type: onAuthReset, payload: null });
      }

      const config = {
        url: `${process.env.REACT_APP_BASE_URL + url}`,
        method,
        data,
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const response = await axios(config);

      if (response?.data?.status) {
        // For General
        dispatch(actions.authApiCallSuccess(response.data));

        // For Specific
        if (onAuthSuccess) {
          dispatch({ type: onAuthSuccess, payload: response.data });
        }
      } else {
        // For General
        dispatch(actions.authApiCallFailed(response?.data));

        // For Specific
        if (onAuthFailed) {
          dispatch({
            type: onAuthFailed,
            payload: response?.data,
          });
        }
      }
    } catch (error: any) {
      // For General
      dispatch(actions.authApiCallFailed(error.response && error.response.data ? error.response.data : error));

      // For Specific
      if (onAuthFailed) {
        dispatch({
          type: onAuthFailed,
          payload: error.response && error.response.data ? error.response.data : error,
        });
      }
    }
  };

export default api;
